import { render, staticRenderFns } from "./MilitaryStatusTypeTable.vue?vue&type=template&id=5c96f41a&"
import script from "./MilitaryStatusTypeTable.vue?vue&type=script&lang=js&"
export * from "./MilitaryStatusTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports